import { render, staticRenderFns } from "./AllOrdersView.vue?vue&type=template&id=54601248&scoped=true"
import script from "./AllOrdersView.vue?vue&type=script&lang=js"
export * from "./AllOrdersView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54601248",
  null
  
)

export default component.exports